import axiosClient from 'utils/axiosClient';
import api from 'api';

const getPrints = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY.PRINTING.PRINTING, {params: data});
	return response.data;
};

const recordPrint = async (data: any) => {
	const response = await axiosClient.post(api.LIBRARY.PRINTING.PRINTING, data);
	return response.data;
};

const getPrintBalance = async (studentID: any) => {
	const response = await axiosClient.get(api.LIBRARY.PRINTING.PRINT_BALANCE_BY_STUDENT_ID + studentID);
	return response.data;
};

const service = {
	getPrints,
	recordPrint,
	getPrintBalance
};

export default service;
